<template>
    <template v-if="isInitialize && !isWait && !isError">
        <ClassicLayout v-if="validTheme(Enums.THEME.CLASSIC)">
            <router-view :key="$route.fullPath" v-if="!isWaitSub" />
        </ClassicLayout>
        <EmptyLayout v-else>
            <router-view :key="$route.fullPath" v-if="!isWaitSub" />
        </EmptyLayout>
    </template>
    <template v-else-if="isError">
        <div class="layout-theme empty">
            <ErrorView page="App" :msg="error"></ErrorView>
        </div>
    </template>
    <template v-else>
        <PageLoader :isPage="true" :isLoaded="false" />
    </template>
</template>
<script>
    import { reactive, toRefs, computed, watch, onMounted, nextTick } from "vue";
    import { useRoute } from "vue-router";
    import { useStore } from "vuex";
    
    import { Tooltip } from 'bootstrap'

    import { Constants } from "@/helpers/constants";
    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C, J } from "@/helpers/global";
    import { Ajax, MethodType, Web } from "@/helpers/web";

    import EmptyLayout from "@/layouts/EmptyLayout.vue";
    import ClassicLayout from "@/layouts/ClassicLayout.vue";
    
    import ErrorView from "@/views/ErrorView.vue";
    import PageLoader from "@/components/PageLoader.vue";

    import { SettingService } from "@/services/api/setting";    
    import { PersonService } from "@/services/api/person";
    import { NotificationService } from "@/services/api/notification";

    import { StorePerson } from "@/store/constants";

    export default {
        name: "App",
        components: {
            EmptyLayout,
            ClassicLayout,
            ErrorView,
            PageLoader,
        },
        setup() {
            const version = "1.83.259";

            if (process.env.NODE_ENV === "production") {
                appData.base = "https://admin.rehberimsensin.com/";
                appData.serverBase = "https://api.rehberimsensin.com/";
                appData.mediaBase = "https://doc.rehberimsensin.com/";
                appData.meetBase = "https://meet.rehberimsensin.com/";
            }
            else if (process.env.NODE_ENV === "staging") {
                appData.base = "https://dev.admin.rehberimsensin.com/";
                appData.serverBase = "https://dev.api.rehberimsensin.com/";
                appData.mediaBase = "https://dev.doc.rehberimsensin.com/";
                appData.meetBase = "https://meet.rehberimsensin.com/";
            }
            else { // Local
                const frontEnd = false;  // TODO: Front-End ise bu alan� true yap

                appData.base = window.location.origin + "/";
                if (frontEnd) { // Front-end verileri localden almaz!
                    appData.serverBase = "https://dev.api.rehberimsensin.com/";
                    appData.mediaBase = "https://dev.doc.rehberimsensin.com/";
                    appData.meetBase = "https://meet.rehberimsensin.com/";
                }
                else {
                    appData.serverBase = "https://localhost:52002/";
                    //appData.mediaBase = "https://localhost:52008/"; // Medya Sunucu i�in
                    appData.mediaBase = "https://localhost:52002/doc/";
                    appData.meetBase = "https://localhost:52010/";
                }
            }

            const route = useRoute();
            const store = useStore();

            const e = reactive({
                isInitialize: false,
                isWait: true,
                isWaitSub: true,
                error: null,
                page: {
                    css: {},
                    theme: Enums.THEME.NULL,
                    header: {},
                },
                isError: computed(() => {
                    return C.Str(e.error) != "";
                }),
                validVersion() {
                    if (version != C.Str(localStorage.getItem("version"))) {
                        localStorage.clear();
                        sessionStorage.clear();

                        store.replaceState({});

                        localStorage.setItem("version", version);
                        Web.Refresh();
                    }
                    return true;
                },
                validTheme(theme) {
                    return e.page.theme == theme;
                },
                getInitData: async () => {
                    await SettingService.InitAsync().then(async (data) => {
                        appData.initialize(data);
                        e.page.theme = C.Int(route.meta.theme);
                        e.isInitialize = true;
                        await e.loadCss();
                        await e.loginDetect();
                    }).catch((error) => {
                        e.error = error;
                    });
                },
                loginDetect: async () => {
                    if (e.isInitialize) {
                        e.page.theme = C.Int(route.meta.theme);
                        if (!e.validTheme(Enums.THEME.NULL)) {
                            if (!e.validTheme(Enums.THEME.EMPTY)) {
                                await PersonService.GetTokenIsLogin(async () => {
                                    nextTick(() => {
                                        document.getElementById('modals').style.display = null;
                                        setTimeout(() => {
                                            e.isWait = false;
                                            e.isWaitSub = false;
                                        }, 200);
                                    });
                                    await e.getLoginData();
                                });
                            }
                            else {
                                 nextTick(()=> {
                                     document.getElementById('modals').style.display = null;
                                     setTimeout(() => {
                                        e.isWait = false;
                                        e.isWaitSub = false;
                                    }, 200);
                                 });
                            }
                        }
                    }
                },
                getLoginData: async () => {
                    //await NotificationService.ListenServer();
                },
                scrollTop() {
                    try {
                        //const psInstance = document.querySelector(".main-content");
                        const psInstance = document.querySelector(".content-card");
                        if(psInstance) {
                            psInstance.scrollTop = 0;
                            psInstance.classList.remove("ps--active-y");
                        }
                    } catch (error) {}
                },
                loadCss: async () => {
                    new Tooltip(document.body, {
                        selector: "[data-bs-toggle='tooltip']",
                    });
                },
            });
            watch(route, (newValue, oldValue) =>
            {
                if (e.isInitialize) {
                    try {
                        appData.page = {}; // temp data kullanimi
                        e.isWait = true;
                        e.isWaitSub = true;
                        e.page.theme = C.Int(route.meta.theme);
                        e.loginDetect();
                    } catch (ex) {
                        e.error = ex.message;
                    }
                    e.scrollTop();
                }
            },
            {
                deep: true,
                immediate: true,
            });
            return { ...toRefs(e) };
        },
        async mounted() {
            try {
                if (this.validVersion()) {
                    await this.getInitData();
                }
            } catch (ex) {
                this.error = ex.message;
            }
        }
    }
</script>